// Wallet balances (new/legacy) and account balance - English
export default {
  common: {
    totalPrefix: "Total ",
    totalSuffix: " items",
    download: "Download",
    downloadFilename: "Details",
    loading: "Loading...",
    empty: "No Data",
    copySuccess: "Copied!",
  },
  detail: {
    dialogTitle: "Balance Details",
    top: {
      address: "Address:",
      addressBalanceUSDT: "Total Address Balance (USDT):",
    },
    columns: {
      currency: "Currency",
      quantity: "Quantity",
      balanceUSDT: "Balance (USDT)",
      updateTime: "Updated Time",
    },
  },
  newWallet: {
    columns: {
      address: "Address",
      balance: "Balance",
      actions: "Actions",
      viewDetails: "View Details",
    },
  },
  wallet: {
    columns: {
      currency: "Currency",
      balance: "Balance",
    },
  },
  account: {
    columns: {
      type: "Account Type",
      balanceUSDT: "Balance (USDT)",
    },
  },
};
